/**
 * Shared metadata for the 6 party-mode IDs. Single source of truth used by:
 *   - PartyLobby.jsx          (mode badge + switcher)
 *   - PartyInstructions.jsx   (rules screen mode header)
 *   - PartyPlayerScreen.jsx   (mode badge on the player phone)
 *   - PartyModeSelect.jsx     (already inlines its own list — could be migrated)
 *
 * Render a mode badge with:
 *
 *   const Icon = MODE_ICONS[mode]
 *   <span className="…">
 *     <Icon size={15} /> {MODE_NAMES[mode]}
 *   </span>
 *
 * The legacy 'bracket' mode is intentionally absent — it's not in the redesign
 * and isn't routed anywhere in the live app.
 */

import {
  IconSwords, IconStopwatch, IconVersus, IconTeam, IconDirectorChair, IconTrophy,
} from '../icons'

export const MODE_NAMES = {
  'battle-royale': 'Battle Royale',
  'speed-run':     'Speed Run',
  'h2h':           'H2H',
  'co-op':         'Co-Op',
  'directors-cut': "Director's Cut",
  'trilogy':       'The Trilogy',
}

export const MODE_ICONS = {
  'battle-royale': IconSwords,
  'speed-run':     IconStopwatch,
  'h2h':           IconVersus,
  'co-op':         IconTeam,
  'directors-cut': IconDirectorChair,
  'trilogy':       IconTrophy,
}

/**
 * Helper for falling back gracefully when a mode ID doesn't match the live set
 * (e.g. an old saved game with a retired mode). Returns the ID itself so the
 * UI doesn't render `undefined`.
 */
export const modeName = (id) => MODE_NAMES[id] || id || ''
export const modeIcon = (id) => MODE_ICONS[id] || null
